(function () {
  'use strict';

  var MARKETS = {
    sv: { country: 'SE', locale: 'sv', currency: 'SEK', usesDkk: false },
    en: { country: 'SE', locale: 'en', currency: 'SEK', usesDkk: false },
    da: { country: 'DK', locale: 'da', currency: 'DKK', usesDkk: true }
  };

  var DEFAULT_SEK_TO_DKK = 0.63;
  var RELOAD_KEY = 'se_dk_market_reload';

  function isDanishDomain() {
    try {
      var host = String(location.hostname || '').replace(/^www\./i, '').toLowerCase();
      return host === 'soffexpert.dk' || host.endsWith('.soffexpert.dk');
    } catch (e) {
      return false;
    }
  }

  function getLang() {
    if (isDanishDomain()) return 'da';
    if (window.SoffexpertI18n) return window.SoffexpertI18n.getLang();
    try {
      return localStorage.getItem('soffexpert_lang') || 'sv';
    } catch (e) {
      return 'sv';
    }
  }

  function getMarket() {
    return MARKETS[getLang()] || MARKETS.sv;
  }

  function getActiveCurrency() {
    return String((window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '').toUpperCase();
  }

  function getCurrentCountry() {
    return String((window.Shopify && window.Shopify.country) || '').toUpperCase();
  }

  function getSekToDkkRate() {
    if (window.Shopify && window.Shopify.currency) {
      var active = getActiveCurrency();
      var rate = Number(window.Shopify.currency.rate);
      if (active === 'DKK' && rate > 0 && rate < 2) return rate;
    }
    return DEFAULT_SEK_TO_DKK;
  }

  function convertSek(amountSek) {
    var market = getMarket();
    if (!market.usesDkk) return Math.round(amountSek);
    return Math.round(amountSek * getSekToDkkRate());
  }

  function formatNumber(n) {
    return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  }

  function formatMoneyFromSek(amountSek) {
    var market = getMarket();
    var value = convertSek(amountSek);
    return formatNumber(value) + ' ' + market.currency;
  }

  function formatMoneyColonFromSek(amountSek) {
    var market = getMarket();
    var value = convertSek(amountSek);
    if (market.usesDkk) return formatNumber(value) + ' DKK';
    return formatNumber(value) + ':-';
  }

  function formatFreeLabel() {
    var market = getMarket();
    if (market.usesDkk) return 'Gratis (0 DKK)';
    return 'Gratis (0 SEK)';
  }

  function postLocalization(country, locale) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var body = new URLSearchParams({
      form_type: 'localization',
      utf8: '✓',
      _method: 'put',
      country_code: country
    });
    if (locale) body.set('locale_code', locale);
    return fetch(root + 'localization', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Accept': 'application/json'
      },
      credentials: 'same-origin',
      body: body.toString()
    }).catch(function () { return null; });
  }

  /** Parse Swedish/Shopify money text like "kr 7.399,00 SEK" or "7 399 kr" → SEK major units */
  function parseMoneyToSek(text) {
    if (!text) return null;
    var t = String(text).replace(/\u00a0/g, ' ').trim();
    if (!/sek|kr/i.test(t) && !/\d/.test(t)) return null;
    if (/dkk/i.test(t)) return null;

    var m = t.match(/(\d{1,3}(?:[.\s]\d{3})*|(\d+)),(\d{2})/);
    if (m) {
      var whole = m[1].replace(/[.\s]/g, '');
      return Number(whole + '.' + m[3]);
    }

    m = t.match(/(\d[\d\s.]*)/);
    if (!m) return null;
    var raw = m[1].replace(/\s/g, '');
    if (raw.indexOf('.') !== -1 && raw.indexOf(',') === -1) {
      var parts = raw.split('.');
      if (parts[parts.length - 1].length === 2 && parts.length > 1) {
        return Number(parts.slice(0, -1).join('') + '.' + parts[parts.length - 1]);
      }
      return Number(raw.replace(/\./g, ''));
    }
    return Number(raw.replace(/\./g, '').replace(',', '.'));
  }

  function convertTextSekToDkk(text) {
    var sek = parseMoneyToSek(text);
    if (sek == null || isNaN(sek)) return null;
    return formatMoneyFromSek(sek);
  }

  function shouldClientConvertPrices() {
    return getMarket().usesDkk && getActiveCurrency() !== 'DKK';
  }

  function convertShopifyPriceNodes(root) {
    if (!shouldClientConvertPrices()) return;
    var scope = root || document;
    var nodes = scope.querySelectorAll(
      '.price-item, .price__compare, .totals__total-value, .cart-item__discounted-prices, ' +
      '.cart-item__old-price, .product__price, .price-item--regular, .price-item--sale, ' +
      '[data-se-money], .money'
    );

    nodes.forEach(function (el) {
      if (el.closest('[data-se-no-convert]')) return;
      if (el.children.length > 1 && el.querySelector('s, .price-item')) return;

      if (el.children.length === 0 || (el.children.length === 1 && el.children[0].tagName === 'S')) {
        var original = el.__seMoneyOrig != null ? el.__seMoneyOrig : el.textContent;
        if (el.__seMoneyOrig == null) el.__seMoneyOrig = original;
        var converted = convertTextSekToDkk(original);
        if (converted) el.textContent = converted;
        return;
      }

      Array.prototype.forEach.call(el.childNodes, function (node) {
        if (node.nodeType !== 3) return;
        var orig = node.__seMoneyOrig != null ? node.__seMoneyOrig : node.nodeValue;
        if (node.__seMoneyOrig == null) node.__seMoneyOrig = orig;
        var next = convertTextSekToDkk(orig);
        if (next) node.nodeValue = next;
      });
    });

    scope.querySelectorAll('s').forEach(function (el) {
      if (el.closest('[data-se-no-convert]')) return;
      var original = el.__seMoneyOrig != null ? el.__seMoneyOrig : el.textContent;
      if (el.__seMoneyOrig == null) el.__seMoneyOrig = original;
      var converted = convertTextSekToDkk(original);
      if (converted) el.textContent = converted;
    });
  }

  function updatePriceElements(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-se-sek-colon]').forEach(function (el) {
      var sek = Number(el.getAttribute('data-se-sek-colon'));
      if (!sek && sek !== 0) return;
      if (el.__seSekOrig == null) el.__seSekOrig = el.textContent;
      el.textContent = formatMoneyColonFromSek(sek);
    });

    scope.querySelectorAll('[data-se-sek]').forEach(function (el) {
      var sek = Number(el.getAttribute('data-se-sek'));
      if (!sek && sek !== 0) return;
      if (el.__seSekOrig == null) el.__seSekOrig = el.textContent;
      el.textContent = formatMoneyFromSek(sek);
    });

    scope.querySelectorAll('[data-se-sek-sale]').forEach(function (el) {
      var sale = Number(el.getAttribute('data-se-sek-sale'));
      var full = Number(el.getAttribute('data-se-sek-full'));
      if (!sale && sale !== 0) return;
      if (el.__seSekOrig == null) el.__seSekOrig = el.innerHTML;
      var html = '<s>' + formatMoneyFromSek(full) + '</s> ' + formatMoneyFromSek(sale);
      el.innerHTML = html;
    });

    scope.querySelectorAll('[data-se-free-label]').forEach(function (el) {
      if (el.__seSekOrig == null) el.__seSekOrig = el.textContent;
      el.textContent = formatFreeLabel();
    });

    scope.querySelectorAll('[data-se-klarna-months]').forEach(function (el) {
      var months = Number(el.getAttribute('data-se-klarna-months')) || 36;
      var sek = Number(el.getAttribute('data-se-sek'));
      if (!sek) {
        var priceEl = document.querySelector('[data-se-product-price-sek]');
        if (priceEl) sek = Number(priceEl.getAttribute('data-se-product-price-sek'));
      }
      if (!sek) return;
      if (el.__seSekOrig == null) el.__seSekOrig = el.textContent;
      var monthly = Math.max(1, Math.round(convertSek(sek) / months));
      var market = getMarket();
      if (market.usesDkk) {
        el.textContent = 'fra ' + formatNumber(monthly) + ' DKK/måned';
      } else if (getLang() === 'en') {
        el.textContent = 'from ' + formatNumber(monthly) + ' SEK/month';
      } else {
        el.textContent = 'från ' + formatNumber(monthly) + ' SEK/månad';
      }
    });

    convertShopifyPriceNodes(scope);
  }

  function updateRegionLabels(root) {
    var scope = root || document;
    var lang = getLang();
    scope.querySelectorAll('[data-se-region]').forEach(function (el) {
      var sv = el.getAttribute('data-se-label-sv');
      var da = el.getAttribute('data-se-label-da');
      var en = el.getAttribute('data-se-label-en');
      if (el.__seSekOrig == null) el.__seSekOrig = el.textContent;
      if (lang === 'da' && da) el.textContent = da;
      else if (lang === 'en' && en) el.textContent = en;
      else if (sv) el.textContent = sv;
      else el.textContent = el.__seSekOrig;
    });

    scope.querySelectorAll('[data-se-show-market]').forEach(function (el) {
      var wanted = el.getAttribute('data-se-show-market');
      var marketLang = lang === 'da' ? 'da' : 'sv';
      el.hidden = wanted !== marketLang && wanted !== 'all';
    });
  }

  function needsCountryReload(targetLang) {
    var cfg = MARKETS[targetLang] || MARKETS.sv;
    return getCurrentCountry() !== cfg.country;
  }

  function refresh(root) {
    updatePriceElements(root);
    updateRegionLabels(root);
  }

  function applyMarket(lang, opts) {
    var cfg = MARKETS[lang] || MARKETS.sv;
    opts = opts || {};
    var tasks = [Promise.resolve()];

    if (!opts.skipLocalization) {
      tasks.push(postLocalization(cfg.country, cfg.locale));
    }

    return Promise.all(tasks).then(function () {
      if (!opts.skipReload && needsCountryReload(lang)) {
        window.location.reload();
        return 'reloading';
      }
      refresh();
      return 'done';
    });
  }

  function ensureDanishDomainMarket() {
    if (!isDanishDomain()) return Promise.resolve('skip');

    try {
      localStorage.setItem('soffexpert_lang', 'da');
    } catch (e) {}

    if (getActiveCurrency() === 'DKK' || getCurrentCountry() === 'DK') {
      try { sessionStorage.removeItem(RELOAD_KEY); } catch (e) {}
      refresh();
      return Promise.resolve('ok');
    }

    var alreadyTried = false;
    try { alreadyTried = sessionStorage.getItem(RELOAD_KEY) === '1'; } catch (e) {}

    if (alreadyTried) {
      refresh();
      return Promise.resolve('fallback');
    }

    try { sessionStorage.setItem(RELOAD_KEY, '1'); } catch (e) {}

    return postLocalization('DK', 'da').then(function () {
      window.location.reload();
      return 'reloading';
    });
  }

  function ensureSwedishDomainMarket() {
    if (isDanishDomain()) return Promise.resolve('skip');

    var lang = 'sv';
    try {
      var stored = localStorage.getItem('soffexpert_lang');
      if (stored === 'en') lang = 'en';
      else lang = 'sv';
      localStorage.setItem('soffexpert_lang', lang);
    } catch (e) {}

    if (getCurrentCountry() === 'SE' && getActiveCurrency() !== 'DKK') {
      try { sessionStorage.removeItem(RELOAD_KEY); } catch (e) {}
      refresh();
      return Promise.resolve('ok');
    }

    var alreadyTried = false;
    try { alreadyTried = sessionStorage.getItem(RELOAD_KEY) === '1'; } catch (e) {}

    if (alreadyTried) {
      refresh();
      return Promise.resolve('fallback');
    }

    try { sessionStorage.setItem(RELOAD_KEY, '1'); } catch (e) {}

    var cfg = MARKETS[lang] || MARKETS.sv;
    return postLocalization(cfg.country, cfg.locale).then(function () {
      window.location.reload();
      return 'reloading';
    });
  }

  window.SoffexpertRegion = {
    getLang: getLang,
    getMarket: getMarket,
    convertSek: convertSek,
    formatMoneyFromSek: formatMoneyFromSek,
    refresh: refresh,
    applyMarket: applyMarket,
    needsCountryReload: needsCountryReload,
    isDanishDomain: isDanishDomain
  };

  document.addEventListener('soffexpert:langchange', function () {
    refresh();
  });

  document.addEventListener('DOMContentLoaded', function () {
    if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function () {
        setTimeout(function () { refresh(); }, 0);
      });
    }

    if (isDanishDomain()) {
      ensureDanishDomainMarket().then(function () {
        refresh();
      });
      if (typeof MutationObserver !== 'undefined') {
        var timer = null;
        var obs = new MutationObserver(function () {
          clearTimeout(timer);
          timer = setTimeout(function () { refresh(); }, 80);
        });
        obs.observe(document.body, { childList: true, subtree: true });
      }
      return;
    }

    // Swedish domain: restore SE market / Swedish (or English) after flag switch from .dk
    ensureSwedishDomainMarket().then(function () {
      refresh();
    });
  });
})();

